import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Oversize / Super-Load Hauling',
    desc: 'Expert handling of super-loads, including full permit acquisition, route surveys, and escort vehicles.',
    img: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'International Shipping',
    desc: 'Cross-border transport and port delivery services for global heavy equipment logistics.',
    img: 'https://images.unsplash.com/photo-1586528116311-ad8ed7c80a73?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Tractor & Farm Equipment',
    desc: 'Safe and secure nationwide transport for farm tractors, combines, and agricultural implements.',
    img: 'https://images.unsplash.com/photo-1592978868971-4191b29a280e?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Excavator & Construction',
    desc: 'Specialized handling and heavy haul logistics for mini excavators to large crawler excavators.',
    img: 'https://images.unsplash.com/photo-1579847188804-ecba0e2ea330?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Bulldozer & Dozer Hauling',
    desc: 'Expert transport for heavy earthmoving equipment, ensuring safe loading and transit.',
    img: 'https://images.unsplash.com/photo-1504307651254-35680f356f12?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Skid Steer & Compact',
    desc: 'Affordable and fast transport for skid steers, compact track loaders, and smaller machinery.',
    img: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?q=80&w=800&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-brand-navy text-white" data-id="element-289">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-291">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-292">
            Comprehensive Heavy Haul Services
          </h2>
          <p className="text-lg text-slate-300" data-id="element-293">
            From skid steers to massive bulldozers, our heavy haulers have the
            equipment and expertise to handle any machinery transport
            requirement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-294">
          {services.map((service, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="group relative overflow-hidden rounded-2xl bg-brand-navy-light border border-white/10" data-id="element-295">
              <div className="aspect-w-16 aspect-h-9 w-full h-64 overflow-hidden" data-id="element-296">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-297" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/40 to-transparent" data-id="element-298"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-299">
                <h3 className="text-2xl font-bold mb-2" data-id="element-300">{service.title}</h3>
                <p className="text-slate-300" data-id="element-301">{service.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}